import React from "react";

import { Badge } from "@merge-api/merge-javascript-shared";
import { AuditLogRole } from "../../../../../../../models/Entities";
import { BaseColor } from "@merge-api/merge-javascript-shared/dist/designSystem/types";
import { ROLE_LABEL } from "../../../constants";

// END_USER shares `orange` with API — both are non-internal-team actors, and the label text
// disambiguates them. All 7 BaseColors are otherwise assigned to internal-user roles.
const ROLE_COLOR: Record<AuditLogRole, BaseColor> = {
  [AuditLogRole.ADMIN]: "purple",
  [AuditLogRole.DEVELOPER]: "green",
  [AuditLogRole.MEMBER]: "blue",
  [AuditLogRole.SUPPORT]: "red",
  [AuditLogRole.MERGE_TEAM]: "gray",
  [AuditLogRole.SYSTEM]: "yellow",
  [AuditLogRole.API]: "orange",
  [AuditLogRole.END_USER]: "orange",
};

type RoleCellProps = {
  role: AuditLogRole;
};

const RoleCell = ({ role }: RoleCellProps) => {
  const color = ROLE_COLOR[role];
  return (
    <td>
      <Badge color={color} size="md">
        {ROLE_LABEL[role]}
      </Badge>
    </td>
  );
};

export default RoleCell;
